export default Object.freeze({

  YEAR: " ano",
  MONTH: " mês",
  MONTHS: " meses",
  DAY: " dia",
  HOUR: " hora",
  MINUTE: " minuto",
  SELECT_REPORT_TYPE: "Por favor selecione ao menos um canal para gerar o relatório.",

  /// ---------------------------- Menu Bar ---------------------------- 
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",

  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscópio",
  BAR_GRAPH: "Gráfico de barras",
  LOG: "Log",
  REPORT: "Relatório",
  CONFIG: "Configurações",

  PORTUGUESE: "Português",
  ENGLISH: "Inglês",
  SPANISH: "Espanhol",

  UPDATING_LANGUAGE_WAITING: "Alterando idioma, aguarde um instante",
  UNABLE_TO_ALTER_LANGUAGE: "Não foi possivel alterar o idioma do programa.\n",

  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Bom",
  ATTENTION_STRING: "Atenção",
  BAD_STRING: "Ruim",
  FAULT_STRING: "Falha",
  UNKNOWN_STRING: "Desconhecido",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço ou sinal",

  REASON_ASI: "Motivo: ",

  REMOVE_POSITIONING: "Excluir dispositivo em falha",
  REMOVE_DEVICE_MODAL_CONTENT_1: "Tem certeza que deseja excluir o dispositivo?",
  REMOVE_DEVICE_SUCCESS: "O dispositivo será removido na próxima varredura.",
  REMOVE_DEVICE_FAILURE: "Ocorreu um erro ao remover o dispositivo: ",
  ADDRESS: "Endereço",
  AMPLITUDE: "Amplitude",
  DEVIATION: "Desvio",
  NOISE: "Ruído",
  STATUS: "Sinal",
  FAULT: "Falha",
  RETRIES: "Retentativas",
  I0: "I0",
  I1: "I1",
  I2: "I2",
  I3: "I3",

  MILLIVOLT: "V",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  A: "A",
  B: "B",
  MASTERS: "Mestres",
  SLAVES: "Escravos",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  CURRENT_CHANNEL: "Canal atual",

  NETWORK_DATA: "Dados da rede",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "O TS Scope ASi encontrou um erro interno que o impediu de funcionar corretamente. Por favor, reinicie o TS Scope ASi. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  MONGO_OFF: "O TS Scope ASi detectou um erro em sua base de dados interna. Por favor, reinicie o TS Scope ASi. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  PICO_NOT_FOUND: "O TS Scope ASi encontrou um erro interno que o impediu de funcionar corretamente. Por favor, reinicie o TS Scope ASi. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  SCAN_FAIL_FOUND: "O TS Scope ASi perdeu a conexão com a rede ASi, certifique-se de que ele está conectado corretamente à rede. Após realizar a conexão, por favor reinicie o TS Scope ASi.",
  INVERTED_POLARITY_FOUND: "O TS Scope ASi detectou que os cabos conectados a ele estão com as polaridades invertidas. Isso pode causar instabilidade na leitura dos pacotes da rede, fazendo com que escravos inexistentes na rede apareçam na Live List. Para corrigir o problema, reconecte os cabos corretamente e, em seguida, reinicie o TS Scope ASi.",
  INVERTED_POLARITY: "Polaridade invertida",

  A_DEVICES: "Dispositivos A",
  B_DEVICES: "Dispositivos B",

  AMPLITUDE_POPUP_STR1: "Mostra a amplitude atual do sinal de cada um dos dispositivos ASi da rede.",
  AMPLITUDE_POPUP_STR2: "O valor mínimo é de 4 Vpp e o máximo de 8 Vpp.",
  NOISE_POPUP_STR: "O ruído em redes ASi tem como limite 30% do valor da amplitude do sinal.",
  DEV_POPUP_STR1: "Indica o valor de desvio do sinal em relação ao oscilador de frequência, ou seja, a relação de tempo entre onde o sinal deveria cruzar o zero e efetivamente onde está cruzando.",
  DEV_POPUP_STR2: "Pode indicar acoplamento capacitivo ao barramento ou ainda problema no hardware.",
  DEV_POPUP_STR3: "Os limites são -0,8μs a + 1,6μs.",
  RETRIES_POPUP_STR_1: "As retentativas indicam o número de vezes que ocorreu perda de pacote e o mestre precisou reenviar uma pergunta para determinado dispositivo.",
  RETRIES_POPUP_STR_2: "As retentativas são calculadas dentro dos buffers de aquisição de dados do monitor, que funciona realizando aquisições de forma intervalada, alternando pelos 4 canais.",

  STATUS_POPUP_STR_1: "Qualidade do sinal",
  STATUS_POPUP_STR_2: "• Amplitude de 4 a 8 V",
  STATUS_POPUP_STR_3: "• Amplitude de 2,5 a 4 V",
  STATUS_POPUP_STR_4: "• Amplitude menor que 2,5 V",
  STATUS_POPUP_STR_5: " ou Amplitude maior que 8 V",
  STATUS_POPUP_STR_6: "• Indica que o escravo parou de comunicar, ou seja, deixou de trocar dados com o mestre (caiu da rede).",

  I_POPUP_STR: "Estas colunas mostram os bits de dados nas respostas dos escravos.",

  PS: "OBS:",

  CANCEL: "Cancelar",

  NO_ACTIVE_NETWORK: "O TS Scope ASi não encontrou uma rede ativa, certifique-se de que ele está conectado corretamente a uma rede ASi. Após realizar a conexão, por favor reinicie o TS Scope ASi.",

  CHANNEL_TAG_STR: "Tag do canal",
  MASTER: "Mestre",
  SLAVE: "Escravo",

  TIME_ON: "Tempo ligado:",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Gráfico",
  WAVE_FORM: "Forma de onda",
  ADDRESS_DP: "Endereço: ",
  CHANNEL_DP: "Canal: ",
  WAVE_B_A: "Sinal B - A",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",

  TIME_NS: "Tempo (ns)",
  TIME_US: "Tempo (μs)",
  TIME_MS: "Tempo (ms)",

  AMPLITUDE_PLACEHOLDER: "0,0 V",
  TIME_INTERVAL_PLACEHOLDER: "0,0 ",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tempo",
  CONTROLS_POPUP_TEXT: "Após apertar PLAY, a forma de onda é atualizada a cada 2 segundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar os controles é preciso selecionar a visualização manual e escolher um dispositivo.",

  VISUALIZATION: "Visualização",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",

  KBPS: "Kbps",

  TIME_DP: "Tempo: ",

  PS_1: "Obs 1:",
  PS_2: "Obs 2:",
  PS_3: "Obs 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Classificar por",
  AMPLITUDE_ASC: "Amplitude crescente",
  AMPLITUDE_DESC: "Amplitude decrescente",
  ADDRESS_ASC: "Endereço crescente",
  VOLTAGE_V: "Tensão (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensão (V)",
  LOADING: "Carregando",
  BAR_GRAPH_TYPE_PLACEHOLDER: "Selecione um tipo de gráfico de barras",
  MICROSSECOND_TITLE: "Microsegundos (µs)",

  NOISE_ASC: "Ruído crescente",
  NOISE_DESC: "Ruído decrescente",

  DEVIATION_ASC: "Desvio crescente",
  DEVIATION_DESC: "Desvio decrescente",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Por favor, digite um endereço ou um tipo de evento válidos.",
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço ou tipo de evento",
  LOG_WAITING: "Carregando dados do log",
  HORARY: "Horário",
  DESCRIPTION: "Descrição",
  TYPE: "Tipo",

  ASI_DEVIATION_LOG_DESCRIPTION: "O TS Expert detectou uma possível possível condição desvio no sinal ASi.",
  ASI_ATTENUATED_SIGNAL_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de sinal ASi atenuado.",
  ASI_NOISE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de ruído na rede ASi.",
  ASI_NO_SIGNAL_LOG_DESCRIPTION: "O TS Expert detectou que o TS Scope ASi não conseguiu realizar a leitura deste escravo em suas varreduras.",
  ASI_GENERAL_SIGNAL_LOSS_DESCRIPTION: "O TS Scope ASi detectou uma possível perda geral do sinal ASi. Por favor verifique se o cabo foi removido do canal, ou se ele está com mal contato.",
  ASI_RETRY_LOG_DESCRIPTION: "O TS Expert detectou uma possível presença de retentativa.",
  ASI_FAULT_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de falha.",
  EVENT_CHECKED_SUCCESS: "O evento foi limpo com sucesso.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "Relatório TS Scope ASi",

  HEADER_TEXT: "TS Scope ASi",
  GENERATE_REPORT: "Gerar relatório",

  GENERAL_REPORT: "Relatório geral – TS Scope ASi",
  DATA_REPORT: "Relatório de dados – TS Scope ASi",

  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  CONFORMITY: "Conformidade",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",

  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme com restrições",
  NON_CONFORM: "Não conforme",

  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",

  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",

  ETHERNET_INFO: "Informações ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Nome da rede: ",

  SUMMARY: "Sumário",
  CHANNEL: "Canal",
  LIVE_LIST_PAGE_TITLE: "1 - Live List",
  OSCILLOSCOPE_PAGE_TITLE: "2 - Osciloscópio",
  BAR_GRAPH_PAGE_TITLE: "3 - Gráfico de barras",
  LOG_PAGE_TITLE: "4. - Log de eventos",

  LAST_200_EVENTS: "200 últimos eventos",

  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "ASi",

  ANALYZER_VERSION_STRING: "- Versão do TS Scope ASi:",
  ANALYSIS_INIT: "- Horário de início da análise:",

  SOFTWARE_VERSION: "- Versão de software:",
  BAUD_RATE: "- Baud rate:",
  NUM_MASTERS: "- Mestres:",
  NUM_SLAVES: "- Escravos:",

  LIVE_LIST_DOTS: ".....................................................................................................................................",
  BAR_DOTS: "......................................................................................................................",
  OSC_DOTS: ".............................................................................................................................",
  LOG_DOTS: ".............................................................................................................................................",
  DISCLAIMER_DOTS: ".................................................................................................................................",

  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde",

  SIGNAL_DP: "Sinal: ",
  AMPLITUDE_DP: "Amplitude: ",
  DEVIATION_DP: "Desvio: ",
  NOISE_DP: "Ruído: ",

  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em ASi, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro especialista ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",

  RETIES_DP: "Retentativas: ",
  I0_DP: "I0: ",
  I1_DP: "I1: ",
  I2_DP: "I2: ",
  I3_DP: "I3: ",

  // ---------------------------- Manage Information ----------------------------
  SAVE: "Salvar",
  REMOVE: "Remover",
  YES: "Sim",
  NO: "Não",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Entrar",
  LOGOUT: "Logout",
  RESTART_SYSTEM: "Reiniciar Sistema",
  IP: "IP",
  MASK: "Máscara",
  GATEWAY: "Gateway",
  TAG: "Tag",
  SETUP: "Configurar",
  EDIT: "Editar",
  SOFTWARE_UPDATE: "Atualização de Software",
  INTERFACE_CONFIG: "Configurações de Interface",
  CURRENT_VERSION: "Versão atual: ",
  UPDATE: "Atualizar",
  ALTER_LOGIN: "Alterar login",
  ARE_YOU_SURE_ALTER_CONFIG: "Tem certeza que deseja alterar as configurações do TS Scope ASi?",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",

  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",
  GPG_FILE_EXTENSION: ".gpg",

  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILE_WRONG_FILENAME: "Nome inválido. O arquivo de atualização deve chamar-se: updatePB.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",
  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS_1: "O log do 'Canal ",
  CLEAN_LOG_SUCCESS_2: "' foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",
  CLEAR: "Limpar",
  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  INVALID_DNS: "\n- O DNS inserido é inválido",
  LOOPBACK_IP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do TS Scope ASi",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  TAG_TOO_LONG: "O tamanho da tag não pode ultrapassar 30 caracteres",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  SUBNET_OVERLAP_WLAN: "\n- O TS Scope ASi detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- O TS Scope ASi detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do TS Scope ASi",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do TS Scope ASi",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do TS Scope ASi",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",

  CHOOSE_A_CHANNEL: "Para salvar a tag é necessário selecionar um canal",

  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",

  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",

  SELECT_FILE: "Por favor selecione um arquivo para ser enviado",

  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES: "Atualizando arquivos no TS Scope ASi. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Arquivos atualizados, preparando para reiniciar o TS Scope ASi.",
  RESTARTING_MONITOR_WAIT: "Reiniciando o TS Scope ASi, aguarde alguns minutos.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING: "Ocorreu o seguinte erro ao atualizar o TS Scope ASi: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",

  ALTER: "Alterar",
  CHANNELS: "Canais",
  CHANNELS_TAGS: "Tags dos canais",
  DEVICES_TAGS: "Tags dos dispositivos",

  TAG_AND_NOTE_FROM_CHANNEL: "A tag do canal ",
  WAS_SUCCESSFULLY_ALTERED: " foi alterada com sucesso!",
  ALTER_TAG_ERROR: "Ocorreu um erro ao alterar a tag do canal ",
  ALTER_TAG_ERROR_REASON: ".\nMotivo: ",
  ERROR_REASON: ".\nMotivo: ",

  NOTE: "Observação",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuração da interface Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do TS Scope ASi.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuração da interface sem fio, quando adaptador disponível.",
  WLAN_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do TS Scope ASi.",

  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_OFF: "Desligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "Tem certeza que deseja ligar o servidor NTP? Para isso o TS Scope ASi precisará ser reiniciado.",
  TURN_NTP_SERVER_OFF_QUESTION: "Tem certeza que deseja desligar o servidor NTP? Para isso o TS Scope ASi precisará ser reiniciado.",

  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP.",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",

  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",

  MONITOR_RESTART_SUCCESS: "O TS Scope ASi foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE: "Ocorreu um erro ao reiniciar o TS Scope ASi.",

  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "A tag do TS Scope ASi foi modificada com sucesso.",
  TAG_CHANGE_FAILURE: "Ocorreu um erro ao modificar a tag do TS Scope ASi.",

  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / desabilitar as não conformidades a serem informadas pela ferramenta.",
  DNS: "DNS",

  USERNAME: "Usuário",
  NEW_PWD: "Nova senha",
  REPEAT_PWD: "Repetir senha",

  TS_SCOPE_ASI_TAG: "Tag do TS Scope ASi",
  TEST_NETWORK: "Rede de teste",

  TS_SCOPE_ASI_REPORT_CHANNEL: "Relatório TS Scope ASi - Canal",
  REPORTS_TS_SCOPE_ASI: "Relatórios - TS Scope ASi.zip",

  PROJECT_NAME_: "Nome do projeto",
  NETWORK_NAME_: "Nome da rede",
  LOCATION_: "Localização",
  COMPANY_NAME_: "Nome da empresa",
  RESPONSIBLE_NAME: "Nome do responsável",
  ADDRESS_: "Endereço",
  CITY: "Cidade",
  TEL: "Telefone",
  CLIENT_LOGO: "Logo do cliente",
  EMAIL: "E-mail",
  EXECUTING_COMPANY_LOGO: "Logo da empresa executora",
  CHANNELS_INCLUDED_REPORT: "Canais inclusos no relatório",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Adicionar/Alterar Tags",
  CHOOSE_DEVICE: "Escolha um dispositivo",
  NEW_TAG: "Nova TAG",
  REMOVE_ALL_TAGS: "Remover todas as Tags",
  CONFIRM_REMOVE_ALL_TAGS: "Tem certeza que deseja remover as tags de todos os dispositivos?",
  CHANGE_TAG_SUCCESS: "A tag foi alterada com sucesso.",
  CHANGE_TAG_FAILURE: "Ocorreu um erro ao alterar a tag",
  REMOVE_TAG_SUCCESS: "As tags foram removidas com sucesso.",
  REMOVE_TAG_FAILURE: "Ocorreu um erro ao remover as tags",
  IMPORT_TAGS_SUCCESS_1: "As tags do canal ",
  IMPORT_TAGS_SUCCESS_2: " foram importadas com sucesso",

  IMPORT_TAGS_FAILURE: "Ocorreu um erro ao importar as tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor selecione um arquivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  CHOOSE_A_CHANNEL_FIRST: "É necessário selecionar um canal primeiro",
  CHOOSE_A_DEVICE_FIRST: "É necessário selecionar um dispositivo primeiro",

  EXPORT_TAGS_FILENAME: "tags-canal-",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",

  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Força do sinal",
  FREQUENCY: "Frequência",
  QUALITY: "Qualidade",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  QUALITY_PLACEHOLDER: "Qualidade",

  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",

  NETWORK: "Rede",
  NETWORK_NAME_1: "Nome da rede",
  SUBMASK: "Máscara",
  PASSWORD: "Senha",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica o estado do adaptador WLAN do TS Scope ASi.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica se o TS Scope ASi está conectado ou não à rede WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o TS Scope ASi por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",

  WLAN_ADAPTER_NOT_FOUND_1: "O TS Scope ASi não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique se o adaptador está desconectado, ou com mau contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Caso o adaptador não esteja desconectado nem com mau contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",
  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  LOADING_WAITING: "Carregando informações, por favor aguarde.",
  WLAN_INFO: "Informações WLAN",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o TS Scope ASi ou o roteador WLAN.",

  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",

  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",

  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",

  ALTER_MONITOR_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do TS Scope ASi?",

  FIXED_IP: "IP Fixo",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",
  TS_EXPERT_INVERTED_POLARITY_DISABLE_NOT_ALLOWED: "Não é possível desabilitar este evento!",

  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",

  ASI_ATTENUATED_SIGNAL_LIST_HEADER: "Sinal atenuado",
  ASI_ATTENUATED_SIGNAL_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de sinal ASi atenuado.",

  ASI_DEVIATION_LIST_HEADER: "Desvio",
  ASI_DEVIATION_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição desvio no sinal ASi.",

  ASI_NO_SIGNAL_LIST_HEADER: "Sem sinal",

  ASI_NOISE_LIST_HEADER: "Ruído",
  ASI_NOISE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de ruído na rede ASi.",

  ASI_GENERAL_SIGNAL_LOSS_HEADER: "Perda geral de sinal ASi",

  ASI_RETRY_LIST_HEADER: "Retentativa",
  ASI_RETRY_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível presença de retentativas.",

  ASI_FAULT_LIST_HEADER: "Falha",
  ASI_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de falha.",

  ASI_INVERTED_POLARITY_LIST_HEADER: "Polaridade invertida",
  ASI_INVERTED_POLARITY_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de polaridade invertida.",

  // ---------------------------- TS EXPERT ----------------------------
  SCOPE_TAG: "Tag do Scope:",
  CHANNEL_TAG_2: "Tag do canal:",
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de ações - TS Expert - TS Scope ASi",

  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Scope ASi em redes ASi.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado em: ",
  CHECK_YOUR_NETWORK: "Por favor verifique sua rede.",

  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Ações",

  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum evento na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",

  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",

  DETAILING: "Detalhamento",

  CHECKED: "Limpar",
  BATCH_CHECK: "Limpar todos",

  PROBLEM_CHECKED: "O evento foi limpo com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao limpar o evento.",

  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",

  DEVICES: "Dispositivos",
  UNKNOWN: "Desconhecido",

  ALL_EVENTS_WERE_CHECKED: "Todos os eventos foram conferidos com sucesso.",
  CHECK_EVENT_OBS: "\nImportante salientar que alguns dados levam até 15 minutos para serem atualizados, desta forma, sugere-se aguardar algum tempo para limpar esta lista clicando em conferir.\n",

  UNABLE_TO_CHECK_DEVIATION_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope ASi continua detectando uma condição de jitter no sinal da rede ASi:\n",
  UNABLE_TO_CHECK_ATTENUATED_SIGNAL_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope ASi continua detectando sinal com amplitude menor que 4Vpp:\n",
  UNABLE_TO_CHECK_NOISE_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope continua detectado uma condição de ruído (mplitude maior que 30% da amplitude do sinal do escravo):\n",
  UNABLE_TO_CHECK_RETRY_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope ASi continua detectando retentativas:\n",
  UNABLE_TO_CHECK_FAULT_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope ASi continua detectando uma condição de falha:\n",
  UNABLE_TO_CHECK_INVERTED_POLARITY_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope ASi continua detectando uma condição de polaridade invertida:\n",

  SAVE_ACTIONS_LIST: "Salvar lista de ações",
  FINISHING: "Finalizando...",
  ACTIONS_LIST_SCOPE_CHANNEL: "Lista de ações - TS Scope ASi - Canal",
  PAGE: "Página",

  // ---------------------------- DESVIO ----------------------------
  DEVIATION_SUGGESTION_1: "O alerta “desvio” indica que TS Scope ASi encontrou em suas varreduras uma condição de jitter no sinal da rede ASi.",
  DEVIATION_SUGGESTION_2: "Verificar os seguintes itens:",
  DEVIATION_SUGGESTION_3: "Isolamento dos equipamentos;",
  DEVIATION_SUGGESTION_4: "Umidade no barramento;",
  DEVIATION_SUGGESTION_5: "Problemas na eletrônica dos escravos;",
  DEVIATION_SUGGESTION_6: "Oxidações nas conexões dos escravos;",
  DEVIATION_SUGGESTION_7: "Oxidações nas conexões das junction box / barreiras;",
  DEVIATION_SUGGESTION_8: "Cabo longo.",

  // ---------------------------- SINAL ATENUADO ----------------------------
  ATTENUATED_SIGNAL_SUGGESTION_1: "O alerta “sinal atenuado” indica que TS Scope ASi encontrou em suas varreduras sinais com amplitude menor que 4Vpp.",
  ATTENUATED_SIGNAL_SUGGESTION_2: "Realizar as seguintes verificações:",
  ATTENUATED_SIGNAL_SUGGESTION_3: "Se a eletrônica dos escravos está interferindo no barramento, isolando-os individualmente do barramento;",
  ATTENUATED_SIGNAL_SUGGESTION_4: "Se há pontos de alta resistência como bornes frouxos e cabos amassados.",
  ATTENUATED_SIGNAL_SUGGESTION_5: "Se a eletrônica do gateway está interferindo no barramento, substituindo por outro.",

  // ---------------------------- RUIDO ----------------------------
  NOISE_SUGGESTION_1: "O alerta “ruído” indica que TS Scope ASi encontrou em suas varreduras uma condição de ruído com amplitude maior que 30% da amplitude do sinal do escravo.",
  NOISE_SUGGESTION_2: "Abaixo temos 3 dicas para ajudar a solucionar este problema:",
  NOISE_SUGGESTION_3: "Verificar o isolamento das interfaces dos escravos, um modo simples é desconectando um a um da rede e verificando se o problema persiste.",
  NOISE_SUGGESTION_4: "Para atenuar o ruído é necessário verificar se todos os escravos da rede estão devidamente aterrados;",
  NOISE_SUGGESTION_5: "É necessário verificar a equipotencialização do sistema de terra, um modo simples é verificar se há corrente de fuga nos cabos ASi.",

  // ---------------------------- RETENTATIVAS ----------------------------
  RETRY_SUGGESTION_1: "As retentativas indicam o número de vezes que ocorreu perda de pacote e o mestre precisou reenviar uma pergunta para determinado dispositivo.",
  RETRY_SUGGESTION_2: "As retentativas são calculadas dentro dos buffers de aquisição de dados do monitor, que funciona realizando aquisições de forma intervalada, alternando pelos 4 canais.",
  RETRY_SUGGESTION_3: "Abaixo temos 3 dicas para ajudar a solucionar este problema:",
  RETRY_SUGGESTION_4: "Verificar danos ao cabo:",
  RETRY_SUGGESTION_5: "Verificar se há cabos de potência próximos a cabos ASi. Cabos de dados devem estar separados o mais distante possível ou em eletrocalhas/eletrodutos fechados e aterrados, seguindo o mínimo indicado pelas diretrizes de acordo com a classificação do condutor elétrico, norma EN50174;",
  RETRY_SUGGESTION_6: "Caso nenhum dos itens acima resolva, e um determinado equipamento esteja apresentando retentativas isoladamente (apenas um determinado escravo apresenta retentativas), sugere-se substituir o escravo.",

  // ---------------------------- FALHA ----------------------------
  FAULT_SUGGESTION_1: "O estado “Falha” indica que o escravo parou de comunicar, ou seja, deixou de trocar dados com o mestre (caiu da rede).",
  FAULT_SUGGESTION_2: "Neste caso não há como determinar o motivo exato da falha, sugere-se então:",
  FAULT_SUGGESTION_3: "Verificar a alimentação do escravo;",
  FAULT_SUGGESTION_4: "Verificar se está conectado à rede (cabo ou fibra óptica);",
  FAULT_SUGGESTION_5: "Verificar a integridade e correta montagem do conector;",
  FAULT_SUGGESTION_6: "Verificar a integridade do cabo.",

  // ---------------------------- POLARIDADE INVERTIDA ----------------------------
  INVERTED_POLARITY_SUGGESTION_1: "O TS Scope ASi detectou que os cabos conectados a ele estão com as polaridades invertidas. Isso pode causar instabilidade na leitura dos pacotes da rede, fazendo com que escravos inexistentes na rede apareçam na Live List. Para corrigir o problema, reconecte os cabos corretamente e, em seguida, reinicie o TS Scope ASi",

  // ---------------------------- EXPERT REPORT ----------------------------
  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Lista de ações",

  REPORT_GENERATION: "- Horário de geração do relatório:",
  CHANNEL_TAG: "- Tag do canal: ",

  ASI_DEVIATION_PAGE_TITLE: ". - Desvio",
  ASI_ATTENUATED_SIGNAL_PAGE_TITLE: ". - Sinal atenuado",
  ASI_NOISE_PAGE_TITLE: ". - Ruído",
  ASI_FAULT_PAGE_TITLE: ". - Falha",
  ASI_RETRY_PAGE_TITLE: ". - Retentativa",
  ASI_INVERTED_POLARITY_PAGE_TITLE: ". - Polaridade invertida",

  ASI_DEVIATION_DOTS: ".......................................................................................................................................",
  ASI_ATTENUATED_SIGNAL_DOTS: ".........................................................................................................................",
  ASI_NOISE_DOTS: ".........................................................................................................................................",
  ASI_FAULT_DOTS: ".........................................................................................................................................",
  ASI_RETRY_DOTS: "...............................................................................................................................",
  INVERTED_POLARITY_DOTS: ".................................................................................................................",
  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",

  SUGGESTION: "Sugere-se",
  EVIDENCE: "Evidências",
  EVIDENCE_DESCRIPTION: "Captura de evidência da não conformidade informada pelo TS Expert:",

  ASI_DEVIATION_PAGE_DESCRIPTION: "O TS Expert está indicando uma possível condição desvio no sinal ASi.",
  ASI_ATTENUATED_SIGNAL_DESCRIPTION: "O TS Expert está indicando uma possível condição de sinal ASi atenuado.",
  ASI_NOISE_DESCRIPTION: "O TS Expert está indicando uma possível condição de ruído na rede ASi.",
  ASI_FAULT_DESCRIPTION: "O TS Expert está indicando uma possível condição de falha.",
  ASI_RETRY_DESCRIPTION: "O TS Expert está indicando uma possível condição de retentativas.",
  INVERTED_POLARITY_DESCRIPTION: "O TS Expert está indicando uma possível condição de polaridade invertida.",

  ASI_FAULT_DESCRIPTION_1: "Em casos de falha, a captura de evidência da não conformidade não é mostrada, uma vez que não há sinal ASi a ser analisado.",
  ASI_FAULT_DESCRIPTION_2: "Em razão disto, abaixo é apresentada uma tabela contendo todos os dispositivos cujos sinais não foram detectados, seus respectívos canais e o horário em que o problema foi detectado.",

  ASI_RETRY_DESCRIPTION_1: "Em casos de retentativas, a captura de evidência da não conformidade não é mostrada.",
  ASI_RETRY_DESCRIPTION_2: "Em razão disto, abaixo é apresentada uma tabela contendo todos os dispositivos cujos sinais não foram detectados, seus respectívos canais e o horário em que o problema foi detectado.",

  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Canais ativos",
  ACTIVE_CHANNELS_POPUP_1: "Permite configurar quais canais do TS Scope ASi estão ativos no momento (Quais canais serão utilizados).",
  ACTIVE_CHANNELS_POPUP_2: "É recomendado desativar todos os canais que não estiverem sendo utilizados no momento.",
  SAVING_ACTIVE_CHANNELS: "Salvando canais ativos, por favor aguarde.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "Os canais ativos foram salvos com sucesso!\nApós apertar OK você será redirecionado para a página inicial do TS Scope ASi.",
  SEND_ACTIVE_CHANNELS_ERROR: "Occoreu um erro ao salvar os canais ativos",
  CANT_TURN_ALL_CHANNELS_OFF: "Não é possível desativar todos os canais do TS Scope ASi ao mesmo tempo.\n\nÉ necessário que ao menos um dos canais permaneça ativo.",

  // ---------------------------- ASI NETWORK VERSION ----------------------------
  ASI_NETWORK_VERSION: "Versão da rede ASi",
  ASI_NETWORK_VERSION_2: "Versão 2.0",
  ASI_NETWORK_VERSION_2_1: "Versão 2.1",
  ASI_NETWORK_VERSION_POPUP_1: "Permite configurar a versão da rede ASi monitorada por cada um dos canais do TS Scope ASi.",
  ASI_NETWORK_VERSION_POPUP_2: "As redes ASi que utilizam o protocolo na versão 2.0 suportam até 32 dispositivos por rede, endereçados de 1 até 32.",
  ASI_NETWORK_VERSION_POPUP_3: "Já as redes ASi que utilizam o protocolo na versão 2.1 ou superior suportam até 64 dispositivos, endereçados de 1A até 32A e de 1B até 32B.",
  DISABLED_CHANNELS_POPUP_1: "Alguns canais podem aparecer como desabilitados nesta tela, e a versão da rede ASi não poderá ser modificada.",
  DISABLED_CHANNELS_POPUP_2: "Isso ocorre quando eles estiverem desligados, para modificar a versão de rede do canal, vá até a tela de configrações dos canais e habilite-os.",
  SEND_ASI_TYPE_SUCCESS_1: "A versão da rede do 'Canal ",
  SEND_ASI_TYPE_SUCCESS_2: "' foi salva com sucesso!",
  SEND_ASI_TYPE_ERROR: "Occoreu um erro ao salvar a versão da rede do 'Canal ",

  // ---------------------------- LOADING ----------------------------
  INITIALIZING_SCOPE_DP: "Inicializando TS Scope ASi, por favor aguarde."

});